import { IForm } from 'core-components/classes/models/IForm'
import Logger from 'core/utils/Logger'

import { IContact } from '../../model/types'

import { mapContactModifiedValues } from './mapContactModifiedValues'
import { mapEmailPixelsAnswer } from './mapEmailPixelsAnswer'

const getCompetitors = (competitors?: string): string[] => {
  if (!competitors) {
    return []
  }

  try {
    return JSON.parse(competitors)
  } catch (err) {
    Logger.error(`Competitors has incorrect type:`, err)
    if (/^[A-Za-z0-9]/.test(competitors)) {
      return [competitors]
    }
    return []
  }
}

export const mapContactFromContactAllData = (data: IForm): IContact => {
  const competitors = getCompetitors(data.Competitors)

  return {
    addressLine1: data.AddressLine1,
    addressLine2: data.AddressLine2,
    addressLine3: data.AddressLine3,
    changeMindset: data.ChangeMindset,
    city: data.City,
    communicationName: data.CommunicationName,
    companyEmail: data.EmailCompany,
    competitors,
    contactStatus: data.ContactStatus,
    country: data.Country,
    countryOfBusiness: data.CountryOfBusinessExt || data.CountryOfBusiness,
    createdBy: data.CreatedBy,
    email: data.EmailExt || data.Email || '',
    emailPixels: mapEmailPixelsAnswer(data),
    facebookLink: data.FacebookLink,
    firstName: data.FirstNameExt || data.FirstName || '',
    gender: data.Gender,
    hpPassportProfileId: data.HPPassportProfileID,
    hpdContactGUID: data.HPD_Contact_GUID,
    hpdPartnerGUID: data.HPD_Partner_GUID,
    hierarchyType: data.HierarchyType,
    isGDPR: Boolean(data.GDPR),
    isHPChampion: Boolean(data.HPChampion),
    isHPHero: Boolean(data.HPHero),
    isNeverCall: Boolean(data.NeverCallExt === 'Y' || data.NeverCall === 'Y'),
    isNeverEmail: Boolean(data.NeverEmailExt === 'Y' || data.NeverEmail === 'Y'),
    isPPA: data.IsPPA,
    isPreferredContact: Boolean(data.PreferredContact),
    isPrimaryPartner: Boolean(data.PrimaryPartner === 'Y'),
    isSabaAdmin: data.IsSabaAdmin,
    isSabaUser: data.IsSabaUser,
    isKeyContact: data.IsKeyContact,
    jobTitle: data.JobTitle,
    lastContactUpdateDate: data.LastContactUpdateDate,
    lastName: data.LastNameExt || data.LastName || '',
    lastPartnerUpdateDate: data.LastPartnerUpdateDate,
    lastRequest: data.LastRequest,
    learnerId: data.LearnerID,
    linkedInLink: data.LinkedInLink,
    locationId: data.LocationID,
    loginId: data.LoginID,
    mainPhoneCode: data.MainPhone_Prefix,
    mainPhoneNumber: data.MainPhone,
    mobilePhoneCode: data.MobilePhone_Prefix || data.MobilePhone_PrefixExt,
    mobilePhoneNumber: data.MobilePhone || data.MobilePhoneExt,
    market: data.Market,
    modified: data.Modified,
    modifiedBy: data.ModifiedBy,
    notCorporateEmailReason: data.NotCorporateEmailReason,
    notCorporateEmailReasonComment: data.NotCorporateEmailReasonComment,
    oldContactId: data.OLD_ContactID,
    oldPartnerId: data.OLD_PartnerID,
    organization: data.Organization,
    parentPartnerId: data.ParentPartnerID,
    photo: data.Photo,
    portalUserTypeCode: data.PortalUserTypeCode,
    preferredLanguage: data.PreferredLanguageExt || data.PreferredLanguage,
    primaryJobRole:
      data.PrimaryJobRoleExt?.split(';').filter(Boolean) ||
      data.PrimaryJobRole?.split(';').filter(Boolean) ||
      [],
    professionalTitle: data.ProfessionalTitle,
    profileTeamComment: data.ProfileTeamComment,
    region: data.Region,
    relationshipStrength: data.RelationshipStrength,
    role: data.Role,
    seniority: data.SeniorityExt || data.Seniority,
    source: data.Source,
    status: data.StatusExt || data.Status,
    taxId: data.TaxID,
    topPartnerId: data.TopPartnerID,
    twitterLink: data.TwitterLink,
    url: data.URL,
    userCreatedDate: data.UserCreatedDate,
    userLastLoginDate: data.UserLastLoginDate,
    userRowId: data.UserRowID,
    userStatus: data.UserStatus,
    whatsAppLink: data.WhatsAppLink,
    workPhoneCode: data.WorkPhone_Prefix || data.WorkPhone_PrefixExt,
    workPhoneNumber: data.WorkPhone || data.WorkPhoneExt,
    workflowStatus: data.WorkflowStatus,
    zipCode: data.ZipCode,
    entryId: data.EntryID,
    entryId375: data.EntryID375,
    entryId379: data.EntryID379,
    contactId: data.ContactIDExt || data.ContactID,
    partnerId: data.PartnerIDExt || data.PartnerID,
    hpRoles:
      data.PR_HP_ROLEExt?.split(';').filter(Boolean) ||
      data.PR_HP_ROLE?.split(';').filter(Boolean) ||
      [],
    modifiedValues: mapContactModifiedValues(data.ModifiedValues?.split(',') || []),
    sourceRequester: data.SourceRequester,
    newContactId: data.NewContactID,
    newPartnerId: data.NewPartnerID,
    salutation: data.SalutationExt || data.Salutation,
    relinkingComment: data.RelinkingComment,
    appId: data.AppId,
  }
}
